module.exports = __webpack_public_path__ + "img/aiNose-B02.408eb39b.jpg";